import { c as _c } from "react/compiler-runtime";
import { loadBasic } from "@tsparticles/basic";
import ParticlesBase, { initParticlesEngine } from "@tsparticles/react";
import { useEffect, useState } from "react";
export const Particles = props => {
  const $ = _c(19);
  const [init, setInit] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      initParticlesEngine(_temp).then(() => {
        setInit(true);
      });
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  if (!init) {
    return null;
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      value: "#a7f3d0"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      close: true,
      fill: true,
      options: {},
      type: []
    };
    t5 = {};
    t6 = {
      x: 50,
      y: 50,
      mode: "percent",
      radius: 0
    };
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {};
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      default: "out"
    };
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t10;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      min: 0.4,
      max: 0.8
    };
    t10 = {
      acceleration: 0,
      enable: false
    };
    $[9] = t10;
    $[10] = t9;
  } else {
    t10 = $[9];
    t9 = $[10];
  }
  let t11;
  let t12;
  let t13;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      center: t6,
      decay: 0,
      distance: t7,
      direction: "top",
      enable: true,
      outModes: t8,
      random: true,
      size: false,
      speed: t9,
      spin: t10,
      straight: true,
      trail: {
        enable: false,
        length: 10,
        fill: {}
      },
      vibrate: false,
      warp: true
    };
    t12 = {
      limit: {
        mode: "delete",
        value: 0
      },
      value: 50
    };
    t13 = {
      value: {
        min: 0.1,
        max: 0.6
      }
    };
    $[11] = t11;
    $[12] = t12;
    $[13] = t13;
  } else {
    t11 = $[11];
    t12 = $[12];
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      color: t3,
      effect: t4,
      groups: t5,
      move: t11,
      number: t12,
      opacity: t13,
      reduceDuplicates: true,
      shape: {
        close: true,
        fill: true,
        options: {},
        type: "circle"
      },
      size: {
        value: {
          min: 0.5,
          max: 1.5
        }
      },
      zIndex: {
        value: 0,
        opacityRate: 1,
        sizeRate: 1,
        velocityRate: 1
      }
    };
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = [];
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      autoPlay: true,
      clear: true,
      defaultThemes: t2,
      delay: 0,
      detectRetina: true,
      duration: 0,
      fpsLimit: 120,
      particles: t14,
      pauseOnBlur: true,
      pauseOnOutsideViewport: true,
      responsive: t15,
      smooth: false,
      style: {},
      themes: [],
      zLayers: 100,
      name: "Absorbers"
    };
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  let t17;
  if ($[17] !== props) {
    t17 = <ParticlesBase id="particles" {...props} options={t16} />;
    $[17] = props;
    $[18] = t17;
  } else {
    t17 = $[18];
  }
  return t17;
};
async function _temp(engine) {
  await loadBasic(engine);
}